import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import CopyWellSelectTable from 'src/Components/Main/WellWorkflow/CopyWellSelectTable/CopyWellSelectTable';
import { ITest } from 'src/Interfaces/TestInterface';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';


@inject('stores')
@observer
class CopyTestDataModal extends React.Component {

    public props: any;

    private WellsStore: WellsStore;
    private TestsStore: TestsStore;
    private MessageStore: MessageStore;

    public state = {
        copyExpenses: true,
        copyProducts: true,
        copyPumps: true,
        copySolids: true,
    };
    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
        this.TestsStore = props.stores.TestsStore;
        this.MessageStore = props.stores.MessageStore;
    }

    private renderCopyCheckbox = (field: string, label: string) => {
        const checked = this.state[field];
        return (
            <div>
        <FormGroup check={true} inline={true}>
            <Label check={true}>
                <Input
                    name={field}
                    id={field}
                    type="checkbox"
                    onChange={this.handleSelect(field)}
                    checked={checked}
                    />{label}
            </Label>
        </FormGroup>
        </div>
        );
    }

    private handleSelect = (field: string) => () => {
        const val = this.state[field];
        this.setState({
            [field]: !val
        });
    }

    @action
    public saveData = async () => {
        const well = this.WellsStore.copyWell;
        if (well) {
            const testList = await this.TestsStore.getTestsCopy(well.id);
            if (testList && testList[0]) {
                const latestTest = await this.TestsStore.getCopyTestDetails(testList[0].id, well.id);
                const currTest = this.TestsStore.test;
                const { copyExpenses, copyPumps, copyProducts, copySolids } = this.state;
                if (copyExpenses) {
                    this.copyExpenses(latestTest, currTest);
                }

                if (copyPumps) {
                    this.copyPumps(latestTest, currTest);
                }

                if (copyProducts) {
                    this.copyProducts(latestTest, currTest);
                }

                if (copySolids) {
                    this.copySolids(latestTest, currTest);
                }
                const savedTest = this.TestsStore.updateTestModel(currTest, this.WellsStore.well.id);
                if (savedTest) {
                    this.MessageStore.addMessage('Data Copied Successfully', 'success');
                }
            }
        }
        
        this.toggleModal();
    }

    public copyPumps = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.pumpData && copyTest.pumpData.pumps) {
            currTest.pumpData.pumps = DeepCopy(copyTest.pumpData.pumps);
            currTest.pumpData.pumps.forEach(pump => pump.id = '');
        }
    }

    public copySolids = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.solidsControlEquips) {
            currTest.solidsControlEquips = DeepCopy(copyTest.solidsControlEquips);
            currTest.solidsControlEquips.forEach(sce => sce.id = '');
        }
    }

    public copyProducts = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.productInventorys) {
            currTest.productInventorys = DeepCopy(copyTest.productInventorys.filter(prod => prod.closingAmount > 0));
            currTest.productInventorys.forEach(prod => {
                prod.id = '';
                const zStr = '' as unknown as number;
                prod.adjustedStartingAmount = zStr;
                prod.amountUsed = zStr;
                prod.closingAmount = zStr;
                prod.cumulativeAmountUsed = zStr;
                prod.cumulativeCost = zStr;
                prod.reallocation = zStr;
                prod.startingAmount = 0;
                prod.totalCost = zStr;
                prod.amountReceived = zStr;
                prod.amountReturned = zStr;
                prod.writeOffAmount = zStr;
            });
        }
    }

    public copyExpenses = (copyTest: ITest, currTest: ITest) => {
        if (copyTest.ebpInventorys) {
            currTest.ebpInventorys = DeepCopy(copyTest.ebpInventorys.filter(ebp => ebp.isRecurring));
            currTest.ebpInventorys.forEach(ebp => {
                const zStr = '' as unknown as number;
                ebp.id = '';
                ebp.referenceNumber = '';
                ebp.quantity = zStr;
                ebp.totalCost = zStr;
                ebp.unit = '';
            });
        }
    }

    public toggleModal = () => {
        this.setState({
            copyExpenses: true,
            copyProducts: true,
            copyPumps: true,
            copySolids: true,
        });
        this.props.toggle();
    }

    public clearSelections = () => {
        this.setState({
            copyExpenses: true,
            copyProducts: true,
            copyPumps: true,
            copySolids: true,
        });
    }

    public render() {
        const open = this.props.open;
        const toggle = this.toggleModal;
        const copyWell = this.WellsStore.copyWell;
        if (open) {
            return (
                <Modal size="lg" isOpen={open} toggle={toggle}>
                    <ModalHeader toggle={toggle}>
                        Copy Well Test Data
                    </ModalHeader>
                    <ModalBody>
                        <CopyWellSelectTable onClear={this.clearSelections} />
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyPumps', 'Pumps')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copySolids', 'Solids Control Devices')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyProducts', 'Products')
                        }
                        {
                            copyWell &&
                            this.renderCopyCheckbox('copyExpenses', 'EBP')
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={toggle}>Cancel</Button>
                        <Button color="primary" disabled={copyWell === undefined} onClick={this.saveData}>Save Data</Button>
                    </ModalFooter>
                </Modal>
            );
        }
        return '';
    }
}

export default CopyTestDataModal;


// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/WellData/CopyTestDataModal/CopyTestDataModal.tsx